import { defineTokens } from '@chakra-ui/react/styled-system';

export const fontSizes = defineTokens.fontSizes({
	'9xl': { value: '6rem' },       // 96px
	'8xl': { value: '4rem' },		 // 64px
	'7xl': { value: '3.5rem' },     // 56px
	'6xl': { value: '2.75rem' },    //	44px
	'5xl': { value: '2.5rem' },     //	40px
	'4xl': { value: '2rem' },    	 //	32px
	'3xl': { value: '1.75rem' },    //	28px
	'2xl': { value: '1.5rem' },     //	24px
	'xl': { value: '1.25rem' },     //	20px
	'lg': { value: '1.125rem' },    //	18px
	'md': { value: '1rem' },        //	16px
	'sm': { value: '0.875rem' },    //	14px
	'xs': { value: '0.75rem' },     //	12px
	'2xs': { value: '0.625rem' },   //	10px
	'3xs': { value: '0.5rem' }      // 8px
});